module.exports = __webpack_public_path__ + "static/media/post-gratitude.8ae08db6.svg";